import createSelector from 'selectorator'
import { identity } from 'ramda'
import { RootState } from 'src/state/types'
import { NAMESPACE } from './constants'
import { TIntegration, TIntegrationsState } from './types'

export const getSlice = <K extends keyof TIntegrationsState>(key: K) =>
  createSelector<RootState, TIntegrationsState[K]>([`api.${NAMESPACE}.${key}`], identity)

export const getIntegrations = getSlice('integrations')

export const getIntegrationsList = createSelector<RootState, TIntegration[]>([getIntegrations], integrations =>
  integrations.filter(
    (integration: TIntegration) => integration.type !== 'TPNConnect' && integration.type !== 'DigitalContracts',
  ),
)

export const getConsumerCanAccessCredex = getSlice('tpnCanUserAccessCredex')

export const getConsumerModulesList = getSlice('tpnConsumerModules')

export const getTpnConsumerEnquiry = getSlice('tpnConsumerEnquiry')

export const getConsumerEnquiryResponse = getTpnConsumerEnquiry
